// ─────────────────────────────────────────────────────────────
// Driver-facing line item filter
// ─────────────────────────────────────────────────────────────
// Client requirement: "Can we not show in the Driver view anything
// that is Service item? (pallet charge, Blending, etc)"
//
// We HIDE items that are fees / services / trucking — identified by
// the account_name they post to, not by unit. Real materials live
// under product-type accounts (Decorative Crushed Gravel, Cobbles,
// Rubble, Boulders, Round Rock, Inventory Asset) regardless of
// whether they're sold by TON, PALLET, or Each (bagged goods).
// ─────────────────────────────────────────────────────────────

// Accounts that represent fees, services, or trucking — hide these
const NON_MATERIAL_ACCOUNT_KEYWORDS = [
  "transportation",      // trucking lines, ocean freight, "Misc.."
  "miscellaneous",       // Misc Fees, Super Sacking Fee, Pallet Charge
  "environmental fee",   // Environmental Fee
  "prepaid expense",     // CC Service Charge
  "service",             // "Blending service (CGS)" and any other Service account
  "blending",            // "Blending service (CGS)" — extra safety
];

const NON_MATERIAL_NAME_KEYWORDS = [
  "boulder weight",
  "blending",            // "Blending-JEB", "Blending with stabilizing binder"
  "pallet charge",
  "super sacking",
  "fuel surcharge",
  "environmental fee",
  "misc fee",
];

// export const isDriverVisibleMaterial = (item: any): boolean => {
//   if (!item) return false;

//   // Always hide trucking lines (kept for defensive reasons — "Load" unit
//   // means trucking and should never appear as a material)
//   const unit = (item.unit || "").toUpperCase();
//   if (unit === "LOAD") return false;

//   // Hide by account name (fees, services, trucking)
//   const accountName = (item.account_name || "").toLowerCase();
//   if (NON_MATERIAL_ACCOUNT_KEYWORDS.some((k) => accountName.includes(k))) {
//     return false;
//   }

//   // Hide specific misbehaving item names
//   const name = (item.name || "").toLowerCase();
//   if (NON_MATERIAL_NAME_KEYWORDS.some((k) => name.includes(k))) {
//     return false;
//   }

//   return true;
// };
export const isDriverVisibleMaterial = (item: any): boolean => {
  if (!item) return false;

  const unit = (item.unit || "").toUpperCase();
  if (unit === "LOAD" || unit === "HOUR") return false;

  const accountName = (item.account_name || "").toLowerCase();

  // If we have account_name info (PO data), use it for fine-grained filtering
  if (accountName) {
    if (NON_MATERIAL_ACCOUNT_KEYWORDS.some((k) => accountName.includes(k))) {
      return false;
    }
  } else {
    // No account_name (SO order_items) — fall back to stricter unit check:
    // only TON / PALLET are definitely materials. "Each" items without account
    // info are ambiguous (could be bagged goods OR misc fees) → hide to be safe.
    if (unit !== "TON" && unit !== "PALLET") return false;
  }

  // Always hide by name for the few misbehaving items
  const name = (item.name || "").toLowerCase();
  if (NON_MATERIAL_NAME_KEYWORDS.some((k) => name.includes(k))) {
    return false;
  }

  return true;
};